import { __assign } from "tslib";
import PropTypes from 'prop-types';
import React from 'react';
import Hammer from 'react-hammerjs';
// These constants are defined in hammerjs, but they are replicated here,
// because the library is imported by react-hammerjs and I don't want to add
// hammerjs to package.json as direct dependency
export var DIRECTION_LEFT = 2;
export var DIRECTION_RIGHT = 4;
export var DIRECTION_UP = 8;
export var DIRECTION_DOWN = 16;
/* eslint-disable no-bitwise */
export var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
export var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var actionMap = {
    click: {
        eventType: 'onTap',
        options: {},
    },
    doubletap: {
        eventType: 'onDoubleTap',
        options: {
            recognizers: {
                tap: {
                    time: 600,
                    taps: 2,
                    interval: 400,
                    threshold: 45,
                },
            },
        },
    },
    swipeleft: {
        eventType: 'onSwipe',
        options: {
            recognizers: {
                swipe: {
                    direction: DIRECTION_LEFT,
                },
            },
        },
    },
    swiperight: {
        eventType: 'onSwipe',
        options: {
            recognizers: {
                swipe: {
                    direction: DIRECTION_RIGHT,
                },
            },
        },
    },
    swipeup: {
        eventType: 'onSwipe',
        options: {
            recognizers: {
                swipe: {
                    direction: DIRECTION_UP,
                },
            },
        },
    },
    swipedown: {
        eventType: 'onSwipe',
        options: {
            recognizers: {
                swipe: {
                    direction: DIRECTION_DOWN,
                },
            },
        },
    },
    swipehorizontally: {
        eventType: 'onSwipe',
        options: {
            recognizers: {
                swipe: {
                    direction: DIRECTION_HORIZONTAL,
                },
            },
        },
    },
    pinchin: {
        eventType: 'onPinchIn',
        options: {
            recognizers: {
                pinch: {
                    enable: true,
                },
            },
        },
    },
    pinchout: {
        eventType: 'onPinchOut',
        options: {
            recognizers: {
                pinch: {
                    enable: true,
                },
            },
        },
    },
};
export default function Gesture(_a) {
    var _b;
    var children = _a.children, action = _a.action, eventHandler = _a.eventHandler;
    var _c = actionMap[action], eventType = _c.eventType, options = _c.options;
    var props = (_b = {},
        _b[eventType] = function (_a) {
            var target = _a.target, center = _a.center, changedPointers = _a.changedPointers, deltaTime = _a.deltaTime, deltaX = _a.deltaX, deltaY = _a.deltaY, direction = _a.direction;
            var startCoords = center;
            var endCoords = center;
            // TODO why just swipe? Pinch has start/end too
            if (eventType === 'onSwipe') {
                var _b = changedPointers[0], endX = _b.screenX, endY = _b.screenY;
                startCoords = { x: endX - deltaX, y: endY - deltaY };
                endCoords = { x: endX, y: endY };
            }
            var pageX = center.x, pageY = center.y;
            return eventHandler({
                target: target,
                pageX: pageX,
                pageY: pageY,
                direction: direction,
                duration: deltaTime,
                endCoords: endCoords,
                startCoords: startCoords,
            });
        },
        _b.options = options,
        _b);
    return React.createElement(Hammer, __assign({}, props), children);
}
Gesture.propTypes = {
    children: PropTypes.node.isRequired,
    action: PropTypes.oneOf(Object.keys(actionMap)).isRequired,
    eventHandler: PropTypes.func.isRequired,
};
